import { StorageKey } from "../../../../enums/StorageKey";
import { t } from "@lingui/macro";
import {
    renderAmountSoPo,
    renderCellText,
    renderCreatedAt,
    renderDate,
    renderStatus,
    renderTransactionType,
} from '../../../../containers/AppPage/Reports/TransactionByContacts/Common/helper';

function getColumns() {
    return [

        {
            key: 'date',
            dataKey: 'date',
            title: t`Date`,
            width: 55,
            flexGrow: 16,
            cellRenderer: renderDate,
            required: true,
        },
        {
            key: 'number',
            dataKey: 'number',
            title: t`No.`,
            width: 0,
            flexGrow: 20,
            cellRenderer: renderCellText,
            required: true,
        },
        {
            key: 'type',
            dataKey: 'type',
            title: t`Type`,
            // TODO
            width: 45,
            flexGrow: 16,
            cellRenderer: renderTransactionType,
        },
        {
            key: 'number2',
            dataKey: 'number2',
            title: t`Ref No.`,
            width: 55,
            flexGrow: 16,
            cellRenderer: renderCellText,
        },
        {
            key: 'title',
            dataKey: 'title',
            title: t`Title`,
            width: 0,
            flexGrow: 26,
            cellRenderer: renderCellText,
        },
        {
            key: 'description',
            dataKey: 'description',
            title: t`Description`,
            width: 0,
            flexGrow: 26,
            cellRenderer: renderCellText,
            defaulto: true,
        },
        {
            key: 'quantity',
            dataKey: 'quantity',
            title: t`Qty`,
            align: 'right',
            width: 130,
            // flexGrow: 0,
            cellRenderer: renderAmountSoPo,
            defaulto: true,
        },
        {
            key: 'balance_quantity',
            dataKey: 'balance_quantity',
            title: t`Balance Qty`,
            align: 'right',
            width: 130,
            // flexGrow: 0,
            cellRenderer: renderAmountSoPo,
            defaulto: true,
        },
        {
            key: 'amount',
            dataKey: 'amount',
            title: t`Amount`,
            align: 'right',
            width: 140,
            // flexGrow: 20,
            cellRenderer: renderAmountSoPo,
        },
        {
            key: 'base_amount',
            dataKey: 'base_amount',
            title: t`Home Amount`,
            align: 'right',
            width: 140,
            // flexGrow: 20,
            cellRenderer: renderAmountSoPo,
            defaulto: true,
        },
        {
            key: 'transfer_status',
            dataKey: 'transfer_status',
            title: t`Transfer Status`,
            width: 0,
            flexGrow: 30,
            cellRenderer: renderStatus,
            defaulto: true,
        },
        {
            key: 'created_at',
            dataKey: 'created_at',
            title: t`Created At`,
            width: 0,
            flexGrow: 20,
            cellRenderer: renderCreatedAt,
        },
    ];
}

export default {
    storageKey: StorageKey.report_sale_order_by_customer,
    getReportLabel: () => t`Sales Orders By Customer`,
    getColumns,
};
